export const COMPONENT_HASNT_BEEN_CONFIGURED_YET =
  'Component "<%= component %>" hasn\'t been configured yet';
